import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConsumerDeviceInteractionModel, PagedConsumerInteractionModel } from '../../../models/consumer/consumer-interaction.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'device-interactions-list-individual',
  templateUrl: './device-interactions-list-individual.component.html',
  styles: []
})
export class DeviceInteractionsListIndividualComponent implements OnInit, OnDestroy {

    constructor(private route: ActivatedRoute) { }

    @Input() data: PagedConsumerInteractionModel;
    clientId: number;
    consumerId: string;
    subscriptions: any[] = [];
    interactions: ConsumerDeviceInteractionModel[] = [];
    pageSize: number = 0;
    page: number = 1;
    totalPages: number = 2;
    isSearching: boolean = true;
    totalItems: number;
    myInteractionsCount: number;
    inProgressCount: number;
    completedCount: number;
    errorCount: number;

    ngOnInit() {

        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));
    }

    ngOnChanges(changes: any) {
        for (let propName in changes) {
            let chng = changes[propName];
            if (propName == "data" && chng.currentValue) {
                this.interactions = chng.currentValue.items;
                this.page = chng.currentValue.currentPage;
                this.pageSize = chng.currentValue.pageSize;
                this.totalItems = chng.currentValue.totalItems;
                this.totalPages = chng.currentValue.totalPages;
                this.myInteractionsCount = chng.currentValue.myInteractionCount;
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
